import React from 'react';
import MediaItem from "./MediaItem/MediaItem.tsx";
import {THEME_COLORS} from "../../../Globals.ts";
import {useAppStore} from "../../../GlobalStore/GlobalStore.ts";
import {getBlurStyles} from "../../../Utils/misc/cssStyleUtils.ts";

interface MediaDisplayProps {}

const MediaDisplay: React.FC<MediaDisplayProps> = ({ }) => {
    const dynamicStateObj = useAppStore((state: any) => state.dynamicStateObj);
    const blurStyles = getBlurStyles([dynamicStateObj.isMenuOpen, dynamicStateObj.isUploadOpen, dynamicStateObj.visiblePopup?.includes("settings")]);

    return (
        <>
            {Object.keys(dynamicStateObj.selectedMedia).length > 0 && (
                <div className={`${THEME_COLORS} ${blurStyles} flex max-h-48 mx-auto w-[96%] max-w-screen-md overflow-x-auto flex-wrap justify-start items-end p-2 bg-neutral-950 bg-opacity-20 z-0 overflow-y-auto border border-neutral-800 rounded-lg`}>
                    {Object.entries(dynamicStateObj.selectedMedia).map(([fileId, file]: [string, any]) => (
                        <MediaItem key={fileId} file={file}/>
                    ))}
                </div>
            )}
        </>
    );
};

export default MediaDisplay;